import { format } from "date-fns";
import { useAuthFetchQuery } from "@rentablo/api";
import { CACHE_KEYS, exchangeRates } from "@rentablo/api/apiv1";

export const useProposeExchangeRate = () => {
  const getExchangeRate = useAuthFetchQuery(
    CACHE_KEYS.EXCHANGE_RATES,
    exchangeRates
  );

  const getProposedExchangeRate = async (
    date: Date | undefined,
    currency: string
  ): Promise<number | undefined> => {
    if (!date || isNaN(date.getTime())) return undefined;
    if (!currency || currency === "EUR") return undefined;
    try {
      const result = await getExchangeRate({
        from: "EUR",
        to: currency,
        date: format(date, "yyyy-MM-dd"),
      });
      return result?.rate || undefined;
    } catch {
      return undefined;
    }
  };

  return {
    getProposedExchangeRate,
  };
};
